import { render, staticRenderFns } from "./DSBillIcon.vue?vue&type=template&id=749df087&scoped=true&"
import script from "./DSBillIcon.vue?vue&type=script&lang=js&"
export * from "./DSBillIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749df087",
  null
  
)

export default component.exports